(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('ua-parser-js'), require('@volcengine/tls-js-sdk'), require('query-string')) :
    typeof define === 'function' && define.amd ? define(['ua-parser-js', '@volcengine/tls-js-sdk', 'query-string'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tracker = factory(global.UaParser, global.tlsJsSdk, global.queryString));
})(this, (function (UaParser, tlsJsSdk, queryString) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var UaParser__default = /*#__PURE__*/_interopDefaultLegacy(UaParser);

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function getUuid() {
        function n() {
            return Math.floor(65536 * (1 + Math.random()))
                .toString(16)
                .substring(1);
        }
        return n() + n() + n() + n() + n() + n() + n() + n();
    }
    function parseUrl(url, domain) {
        if (!url) {
            return {
                path: '',
                params: ''
            };
        }
        var _a = url.split(domain), protocols = _a[0], allPath = _a[1];
        var _b = allPath.split('?'), path = _b[0], query = _b[1];
        if (path.startsWith(':')) {
            // 带端口路由
            path = '/' + path.split(/\:.*?\//)[1];
        }
        if (path.startsWith('/#')) {
            // hash模式
            path = path.substring(2);
        }
        // 解析url 参数
        var parseQuery = queryString.parse(query);
        return {
            host: "".concat(protocols).concat(domain),
            params: parseQuery,
            path: path
        };
    }
    function createRouteEvent(type) {
        var origin = history[type];
        return function () {
            var res = origin.apply(this, arguments);
            var e = new Event(type);
            // console.log(e)
            window.dispatchEvent(e);
            return res;
        };
    }
    var lg = {
        getItem: function (key) {
            return localStorage.getItem("__track__".concat(key)) || '';
        },
        setItem: function (key, val) {
            localStorage.setItem("__track__".concat(key), val);
        }
    };

    var TLS_CONFIG = {
        host: 'tls-cn-beijing.volces.com',
        projectId: '8e7d7b19-aa1b-44a8-b692-8779a7419d3e',
        topicId: '3c09ffdb-1753-4d43-b9d6-bce50c4a9494',
    };

    var Tracker = /** @class */ (function () {
        function Tracker(options) {
            /**
             * 上一个页面href
             */
            this._lastHref = '';
            this._uaInfo = {};
            this._uid = '';
            this._uuid = '';
            this._extra = {};
            this._domReportType = ['click', 'touchstart'];
            this._wtb = null;
            // 资源类型
            this.SourceType = ['SCRIPT', 'LINK', 'IMG', 'AUDIO', 'VIDEO'];
            var _a = options || {}, appId = _a.appId, useHash = _a.useHash, useHistory = _a.useHistory, useDomTrack = _a.useDomTrack, _b = _a.useJsTrack, useJsTrack = _b === void 0 ? false : _b, _c = _a.env, env = _c === void 0 ? '' : _c;
            if (!appId) {
                throw new Error('请配置appId');
            }
            if (!env) {
                throw new Error('请配置env');
            }
            else if (env !== 'prd') {
                Object.assign(TLS_CONFIG, {
                    topicId: '798833ed-f5ae-4770-a7c7-38640cecf74b'
                });
            }
            this._options = options;
            if (useHash) {
                this.listenHash();
            }
            if (useHistory) {
                this.listenHistory();
            }
            if (useDomTrack) {
                this.initDomReport();
            }
            if (useJsTrack) {
                this.listenJsError();
            }
            // 获取Ua信息
            this.getUaInfo();
            this.initWebTracker();
            this.initUuid();
            // 进入页面记为一次pv
            this.sendPv();
        }
        /**
         * 设置用户标识
         */
        Tracker.prototype.setUserId = function (uid) {
            this._uid = uid;
        };
        /**
         * 设置额外参数
         */
        Tracker.prototype.setExtra = function (extra) {
            if (extra === void 0) { extra = {}; }
            this._extra = extra;
        };
        /**
         * sendTrack
         */
        Tracker.prototype.sendTrack = function (tid) {
            var systemInfo = this.getSystemInfo();
            var pageInfo = this.parsePageInfo(this._lastHref);
            var et = 'tc';
            var appInfo = this.getAppData();
            var t = +new Date();
            this.customRequest(__assign(__assign(__assign(__assign({}, systemInfo), pageInfo), appInfo), { et: et, t: t, tid: tid }));
        };
        Tracker.prototype.initWebTracker = function () {
            var wtb = new tlsJsSdk.WebTrackerBrowser({
                host: TLS_CONFIG.host,
                projectId: TLS_CONFIG.projectId,
                topicId: TLS_CONFIG.topicId, // required
            });
            this._wtb = wtb;
        };
        Tracker.prototype.initUuid = function () {
            var localUuid = lg.getItem('uuid');
            if (localUuid) {
                this._uuid = localUuid;
                return;
            }
            var uuid = getUuid();
            this._uuid = uuid;
            lg.setItem('uuid', uuid);
        };
        Tracker.prototype.getUaInfo = function () {
            var ua = UaParser__default["default"](navigator.userAgent);
            var browser = ua.browser, os = ua.os;
            this._uaInfo = {
                si: os.name,
                bi: browser.name,
            };
        };
        Tracker.prototype.getAppData = function () {
            var _a = this._options, appId = _a.appId, release = _a.release, env = _a.env;
            return {
                appId: appId,
                re: release,
                env: env,
                uid: this._uid,
                uuid: this._uuid,
                iext: JSON.stringify(this._extra),
            };
        };
        Tracker.prototype.parsePageInfo = function (lastHref) {
            var domain = document.domain;
            var referrer = document.referrer;
            var _a = parseUrl(lastHref, domain), pp = _a.path, ppq = _a.params;
            var _b = parseUrl(window.location.href, domain), cp = _b.path, cpq = _b.params;
            return {
                d: domain,
                r: referrer,
                pp: pp,
                ppq: JSON.stringify(ppq),
                cp: cp,
                cpq: JSON.stringify(cpq),
            };
        };
        Tracker.prototype.getWindowInfo = function () {
            var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
            return {
                ww: "".concat(innerWidth),
                wh: "".concat(innerHeight),
            };
        };
        Tracker.prototype.getSystemInfo = function () {
            var _a = this.getWindowInfo(), ww = _a.ww, wh = _a.wh;
            var _b = this._uaInfo, si = _b.si, bi = _b.bi;
            return {
                ww: ww,
                wh: wh,
                si: si,
                bi: bi,
            };
        };
        Tracker.prototype.initDomReport = function () {
            var _this = this;
            this._domReportType.forEach(function (event) {
                window.addEventListener(event, function (e) {
                    var target = e.target;
                    var targetValue = target.getAttribute('data-id');
                    if (targetValue) {
                        _this.sendTrack(targetValue);
                    }
                });
            });
        };
        Tracker.prototype.listenHash = function () {
            // 使用了vue-router的系统，hash模式下符合条件时调用的实际上是pushState方法，无法触发haschange、popstate事件
            if (!this._options.useHistory) {
                this.listenHistory();
            }
        };
        Tracker.prototype.listenHistory = function () {
            window.history['pushState'] = createRouteEvent('pushState');
            window.history['replaceState'] = createRouteEvent('replaceState');
            this.triggerEvent(['pushState', 'replaceState', 'popstate']);
        };
        Tracker.prototype.triggerEvent = function (eventList) {
            var _this = this;
            eventList.forEach(function (e) {
                window.addEventListener(e, function () {
                    _this.sendPv();
                });
            });
        };
        // private listenPage () {}
        Tracker.prototype.customRequest = function (data) {
            // 再次catch
            this._wtb.sendImmediate(data).catch(function () { });
        };
        Tracker.prototype.sendPv = function () {
            var lastHref = this._lastHref;
            if (this._lastHref === window.location.href) {
                return;
            }
            this._lastHref = window.location.href;
            var systemInfo = this.getSystemInfo();
            var pageInfo = this.parsePageInfo(lastHref);
            var et = 'ps';
            var appInfo = this.getAppData();
            var t = +new Date();
            this.customRequest(__assign(__assign(__assign(__assign({}, systemInfo), pageInfo), appInfo), { et: et, t: t }));
        };
        Tracker.prototype.listenJsError = function () {
            var _this = this;
            // js错误
            window.addEventListener('error', function (event) {
                var _a = event.target, target = _a === void 0 ? {} : _a, message = event.message, filename = event.filename, error = event.error;
                var nodeName = target.nodeName;
                var params = {};
                var et;
                if (event.message === 'Script error.') {
                    // 跨域脚本中的错误，无法捕获到具体错误信息，由于浏览器基于安全考虑故意隐藏了其它域JS文件抛出的具体错误信息。这样可以有效避免敏感信息无意中被第三方(不受控制的)脚本捕获到，因此，浏览器只允许同域下的脚本捕获具体的错误信息
                    return;
                }
                if (target !== window &&
                    nodeName &&
                    _this.SourceType.indexOf(nodeName) !== -1) {
                    // 资源加载失败
                    var _b = target, bu = _b.baseURI, nn = _b.nodeName, currentSrc = _b.currentSrc, href = _b.href;
                    params = {
                        nn: nn,
                        bu: bu,
                        su: currentSrc || href, // 加载失败文件
                    };
                    et = 'fe'; // 文件加载错误
                }
                else {
                    // 运行错误
                    params = {
                        mg: message,
                        fp: filename,
                        st: error, // 错误栈
                    };
                    et = 'je'; // 运行错误
                }
                _this.sendError(et, params);
            }, true);
            // 取消unhandledrejection捕获
            // 捕获未处理的 Promise 错误，当 Promise 被 reject 且没有 reject 处理器时触发。
            // window.addEventListener('unhandledrejection',  (event) => {
            //   console.log(event);
            //   const {reason} = event;
            //   console.log(reason);
            //   // 火山云的错误不提做示
            //   if (reason.stack.includes('TypeError: Failed to execute \'text\' on \'Response\': body stream already read')) {
            //     event.preventDefault();
            //   }
            // const response = reason.response;
            // //若无响应，则不监控
            // if (!response) {
            //   return;
            // }
            // var desc = response.request.ajax;
            // desc.status = event.reason.status || response.status;
            // this.sendError('ur', {
            //   mg: 'unhandledrejection',
            //   st: event.reason
            // });
            // },true);
        };
        // vue错误捕获， 重写errorHandler方法
        Tracker.prototype.vueError = function (vue) {
            var _this = this;
            var _vueConfigErrorHandler = vue.config.errorHandler;
            vue.config.errorHandler = function (err, vm, info) {
                _this.sendError('ve', {
                    mg: err.toString(),
                    stack: err.stack,
                });
                // 控制台打印错误
                if (typeof console !== 'undefined' &&
                    typeof console.error !== 'undefined') {
                    console.error(err);
                }
                // 执行原始的错误处理程序
                if (typeof _vueConfigErrorHandler === 'function') {
                    _vueConfigErrorHandler.call(err, vm, info);
                }
            };
        };
        // 错误上报， 同时暴露外部使用
        Tracker.prototype.sendError = function (et, data) {
            // 字符串使用mg字段接收
            data = typeof data === 'string' ? { mg: data } : data;
            var systemInfo = this.getSystemInfo();
            var pageInfo = this.parsePageInfo(this._lastHref);
            var appInfo = this.getAppData();
            var t = +new Date();
            this.customRequest(__assign(__assign(__assign(__assign(__assign({}, systemInfo), pageInfo), appInfo), { et: et, t: t }), data));
        };
        return Tracker;
    }());

    return Tracker;

}));
